import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { Input, Label, Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap'
import { createSelector } from 'reselect';
import { toggleTargetUrlModal } from '../../../../../../../slices/modals/reducer';
import { setCreativesDynamicText, setDynamicTextTargetUrl } from '../../../../../../../slices/campaigns/thunk';
import { setActiveDynamicText } from '../../../../../../../slices/campaigns/reducer';

function TargetUrlModal() {
  const dispatch = useDispatch();

  const selectStates = createSelector(state => state, state => ({
    modalState: state.Modal.targetUrlModal,
    selectedPath: state.Feed.selectedPath,
    selectedTag: state.Campaign.selectedTag,
    activeDynamicText: state.Campaign.activeDynamicText
  }));
  const {modalState, selectedPath, selectedTag, activeDynamicText} = useSelector(selectStates);
  const [targetUrl, setTargetUrl] = useState('');

  useEffect(() => {
    if (activeDynamicText) {
      const foundText = activeDynamicText.texts.find(item => item.tag === selectedTag?.tag);
      if (foundText && foundText.hasOwnProperty('targetUrl')) {
        setTargetUrl(foundText.targetUrl); 
      } else {
        setTargetUrl('');
      }
    } else {
      setTargetUrl('');
    }
  }, [selectedTag]);

  function handleChange(e) {
    setTargetUrl(e.target.value);
  }

  function closeModal() {
    dispatch(toggleTargetUrlModal());
  }

  async function setTargetUrlToDynamicText() {
    const activeDynamicText = await dispatch(setDynamicTextTargetUrl({...selectedTag, targetUrl: targetUrl}));
    dispatch(setCreativesDynamicText());
    dispatch(setActiveDynamicText(null));
    setTimeout(() => {
      dispatch(setActiveDynamicText(activeDynamicText));
    }, 1);
    dispatch(toggleTargetUrlModal());
  }

  return (
    <Modal isOpen={modalState} toggle={closeModal} centered size='md'>
      <ModalHeader className='p-3' toggle={closeModal}>
        Set Target URL
      </ModalHeader>
      <ModalBody>
        <div className='w-100 d-flex flex-column'>
          <Label>Target URL</Label>
          <Input type='text' name='targetUrl' onChange={handleChange} value={targetUrl} />
        </div>
      </ModalBody>
      <ModalFooter>
        <button className='btn btn-light' onClick={closeModal}>Close</button>
        <button className='btn btn-success' onClick={setTargetUrlToDynamicText}>Set Target URL</button>
      </ModalFooter>
    </Modal>
  )
}

export default TargetUrlModal
